<template>
  <div class="doc-root">
    <component :is="currentDoc"></component>
  </div>
</template>

<script>
import echoDoc from '../EchoDoc/PrivacyPolicy.vue'
import joychatDoc from '../JoychatDoc/PrivacyPolicy.vue'
import kikoDoc from '../KikoDoc/PrivacyPolicy.vue'
import vavaDoc from '../VavaDoc/PrivacyPolicy.vue'
import vibeoDoc from '../VibeoDoc/PrivacyPolicy.vue'

export default {
  data() {
    return {
      currentDoc: null,
      docMap: {
        echo: echoDoc,
        joychat: joychatDoc,
        kiko: kikoDoc,
        vava: vavaDoc,
        vibeo: vibeoDoc
      }
    }
  },
  mounted() {
    if (this.packageName && this.docMap[this.packageName]) {
      this.currentDoc = this.docMap[this.packageName]
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-root {
  width: 100vw;
  height: 100vh;
}
</style>
